import {useFarm} from 'context/farmContext';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {PostAdPost} from 'services/farm/advertisement/add';

const usePostAd = () => {
  const {resetForm} = useFarm();
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IAddAdPost) => {
      return PostAdPost(payload);
    },
    onSuccess: () => {
      resetForm();
      navigate('/farm/home');
    },
  });

  return {isLoading, mutate};
};

export default usePostAd;
